import {
  Typography,
  Button,
  TextField,
  Box,
  InputAdornment,
  Autocomplete,
  ButtonGroup,
} from '@material-ui/core';
import { useEffect, useState, useRef, useCallback } from 'react';
import toast from 'react-hot-toast';
import { moduleApi } from 'src/api/modulesApi';
import CustomListView from 'src/components/customTable/CustomListView';
import logger from 'src/utils/logger';
import useAuth from 'src/hooks/useAuth';
import setTitle from 'src/utils/setTitle';
import { projectModulesApi } from 'src/api/projectModules';
import RestartAltIcon from '@material-ui/icons/RestartAlt';
import SearchIcon from '@material-ui/icons/Search';
import { debounce } from 'lodash';
import { casesApi } from 'src/api/casesApi';
import ProjectModuleDrawer from './ProjectModuleDrawer';
import AddIcon from '@material-ui/icons/Add';

const ProjectModules = () => {
  setTitle('ERP | Project Modules');
  const baseUrl = '/erp/settings/project-modules';
  const { user } = useAuth();
  const [allModules, setAllModules] = useState<Array<any>>([]);
  const [count, setCount] = useState<number>(0);
  const [isActivated, setIsActivated] = useState<boolean | null>(null);
  const [search, setSearch] = useState<string>(
    JSON.parse(localStorage.getItem('projectModulesPagePg'))?.modulesSearch ||
      ''
  );
  const [page, setPage] = useState<any>(
    JSON.parse(localStorage.getItem('projectModulesPagePg'))?.modulesPageNo || 0
  );
  const [limit, setLimit] = useState<any>(
    JSON.parse(localStorage.getItem('projectModulesPagePg'))
      ?.modulesPageLimit || 25
  );
  const [column, setColumn] = useState<string>(
    JSON.parse(localStorage.getItem('projectModulesPagePg'))?.column || ''
  );
  const [sortVal, setSortVal] = useState<string>(
    JSON.parse(localStorage.getItem('projectModulesPagePg'))?.sort || ''
  );
  const [isDataRendered, setIsDataRendered] = useState<boolean>(false);
  type SortDataTypes = {
    name?: 'asc' | 'desc';
    organization?: 'asc' | 'desc';
    project?: 'asc' | 'desc';
    status?: 'asc' | 'desc';
  };
  const [sortData, setSortData] = useState<SortDataTypes>({
    name:
      JSON.parse(localStorage.getItem('projectModulesPagePg'))?.name || 'asc',
    organization:
      JSON.parse(localStorage.getItem('projectModulesPagePg'))?.organization ||
      'asc',
    project:
      JSON.parse(localStorage.getItem('projectModulesPagePg'))?.project ||
      'asc',
  });
  const [selectedSort, setSelectedSort] = useState<any>(
    JSON.parse(localStorage.getItem('projectModulesPagePg'))?.sort || {
      id: '',
      value: 'asc',
    }
  );

  const [organizations, setOrganizations] = useState<Array<any>>([]);
  const [projects, setProjects] = useState<Array<any>>([]);
  const isInitialLoad = useRef(true);
  const [selectedOrg, setSelectedOrg] = useState<any>(
    JSON.parse(localStorage.getItem('projectModulesPagePg'))
      ?.modulesOrganization || null
  );
  const [selectedProject, setSelectedProject] = useState<any>(
    JSON.parse(localStorage.getItem('projectModulesPagePg'))?.modulesProject ||
      null
  );

  const [isDrawerOpen, setIsDrawerOpen] = useState<boolean>(false);
  const [selectedModule, setSelectedModule] = useState<any>(null);

  const handlePage = (temp: number) => {
    setPage(temp);
  };
  const handleLimit = (temp: number) => {
    setLimit(temp);
  };
  const debouncedSearch = useCallback(
    debounce((searchValue: string) => {
      setSearch(searchValue);
    }, 700),
    []
  );
  const handleSearch = (val: string) => {
    debouncedSearch(val);
  };
  const searchRef = useRef(null);

  useEffect(() => {
    if (!user?.role?.some((roleObj) => roleObj.identifier === 'it22_admin')) {
      window.location.href = '/admin/not-found';
    }
  }, []);

  const [checkedIds, setCheckedIds] = useState<Array<string>>([]);

  const handleStatusToggle = async (id: string, isActive: boolean) => {
    try {
      const response: any = await projectModulesApi.updateStatusById(
        id,
        isActive
      );
      if (response?.status === 200) {
        toast.success('Updated Successfully');
        setIsDataRendered(!isDataRendered);
      }
      if (response?.status === 204) {
        toast.error('try again later');
      }
    } catch (error) {
      logger(error, 'error');
      toast.error('try again later');
    }
  };

  const getAll = async () => {
    try {
      console.log(limit)
      const res = await projectModulesApi.getAllModules({
        page,
        limit,
        search,
        organizationIds: selectedOrg?.id,
        projectIds: selectedProject?.id,
        column: selectedSort?.id,
        // eslint-disable-next-line no-nested-ternary
        sort: selectedSort?.id
          ? selectedSort.value === 'asc'
            ? 1
            : -1
          : undefined,
      });
      if (res?.status === 200) {
        setAllModules(res?.data?.data);
        setCount(res?.data?.totalRecords);
      }
    } catch (error) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message);
        setAllModules([]);
        setCount(0);
      }
    }
  };

  const handleUpdateStatus = async (status: boolean) => {
    try {
      const payload = {
        moduleIds: checkedIds,
        isActive: status,
      };
      const response = await projectModulesApi.bulkUpdateStatus(payload);
      toast.success('Successfully Deactivated');
      setCheckedIds([]);
      getAll();
    } catch (error) {
      logger(error, 'error');
      toast.error('Try again later');
    }
  };

  const getAllOrganizations = async () => {
    try {
      const response = await casesApi.getOrganizationId();

      if (response?.status === 200) {
        setOrganizations(response?.data);
      }
    } catch (error) {
      logger(error, 'error');
      setOrganizations([]);
    }
  };

  const getAllProjects = async (orgId: any) => {
    try {
      const response = await casesApi.getProjectsById(orgId);
      if (response?.status === 200) {
        setProjects(response?.data);
      }
    } catch (error) {
      setProjects([]);
      logger(error, 'error');
    }
  };

  const toggleSortData = (fieldName: string) => {
    type SortStatusType = 'asc' | 'desc';
    let sortStatus: SortStatusType = 'asc';
    // eslint-disable-next-line default-case
    switch (fieldName) {
      case 'organization.name':
        if (sortData.organization === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...sortData,
          organization: sortStatus,
        });
        break;
      case 'project.name':
        if (sortData.project === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...sortData,
          project: sortStatus,
        });
        break;
      case 'name':
        if (sortData.name === 'asc') {
          sortStatus = 'desc';
        }
        setSortData({
          ...sortData,
          name: sortStatus,
        });
        break;
    }
  };
  const getAllSortedData = async (fieldName: string, value: string) => {
    let columnValue = '';
    const fieldToColumnMap = {
      organization: 'organization.name',
      project: 'project.name',
      name: 'name',
    };

    columnValue = fieldToColumnMap[fieldName] || 'defaultSort';
    setColumn(columnValue);
    setSortVal(value);
  };

  const columns = [
    {
      id: 'name',
      label: 'Name',
      isSort: true,
      width: '25%',
    },
    {
      id: 'organization.name',
      label: 'Organization',
      isSort: true,
      width: '25%',
      Cell: (value: any, row: any) => row.organization?.name || '-',
    },
    {
      id: 'project.name',
      label: 'Project',
      isSort: true,
      width: '25%',
      Cell: (value: any, row: any) => row.project?.name || '-',
    },
    {
      id: 'isActive',
      label: 'Status',
      width: '15%',
      Cell: (rowStatus: boolean, row: any) => (
        <Button
          variant="contained"
          onClick={(e) => {
            e.stopPropagation();
            handleStatusToggle(row?.id, !rowStatus);
          }}
          sx={{
            background: rowStatus
              ? 'rgba(7, 83, 0, 0.1)'
              : 'rgba(255, 161, 161, 0.3)',
            color: rowStatus ? 'rgba(29, 122, 21, 1)' : 'red',
            width: '100px',
            '&:hover': {
              background: rowStatus
                ? 'rgba(7, 83, 0, 0.1)'
                : 'rgba(255, 161, 161, 0.3)',
              color: rowStatus ? 'rgba(29, 122, 21, 1)' : 'red',
            },
          }}>
          {rowStatus ? 'Active' : 'Inactive'}
        </Button>
      ),
      isSort: true,
    },
  ];

  const handleOpenDrawer = (e: any, module?: any) => {
    if (module) {
      setSelectedModule(module);
    } else {
      setSelectedModule(null);
    }
    setIsDrawerOpen(true);
  };

  const handleEditClick = (row: any) => {
    handleOpenDrawer(null, row);
  };
  useEffect(() => {
    getAll();
    const projectModulesPagePg = {
      modulesOrganization: selectedOrg,
      modulesProject: selectedProject,
      modulesPageLimit: limit,
      modulesPageNo: page,
      modulesSearch: search,
      organization: sortData?.organization,
      project: sortData?.project,
      name: sortData?.name,
      column,
      sort: selectedSort,
    };
    localStorage.setItem(
      'projectModulesPagePg',
      JSON.stringify(projectModulesPagePg)
    );
  }, [
    selectedOrg,
    selectedProject,
    isActivated,
    page,
    limit,
    search,
    isDataRendered,
    sortData?.organization,
    sortData?.project,
    sortData?.name,
    column,
    selectedSort,
  ]);

  const handleResetFilters = () => {
    if (searchRef.current) {
      searchRef.current.value = '';
    }
    localStorage.removeItem('projectModulesPagePg');
    setPage(0);
    setLimit(25);
    setSearch('');
    setColumn('');
    setSortVal('');
    setSortData({
      name: 'asc',
      organization: 'asc',
      project: 'asc',
    });
    setSelectedSort({
      id: '',
      value: 'asc',
    });
    setSelectedOrg(null);
    setSelectedProject(null);
  };

  useEffect(() => {
    getAllOrganizations();
  }, []);

  useEffect(() => {
    if (selectedOrg) {
      getAllProjects(selectedOrg.id);
      if (!isInitialLoad.current) {
        setSelectedProject(null);
      }
    } else {
      setProjects([]);
      if (!isInitialLoad.current) {
        setSelectedProject(null);
      }
    }
    isInitialLoad.current = false;
  }, [selectedOrg]);

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedModule(null);
  };

  return (
    <>
      <Typography
        variant="h3"
        style={{
          marginTop: '16px',
          marginBottom: '10px',
          fontSize: '20px',
          fontWeight: '700',
          color: '#000',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        <span>Project Modules</span>
      </Typography>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: 2,
        }}>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            inputRef={searchRef}
            size="small"
            variant="outlined"
            defaultValue={search}
            placeholder="Search..."
            onChange={(e) => handleSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon color="action" />
                </InputAdornment>
              ),
              style: { height: '40px', width: '240px' },
            }}
          />

          <Autocomplete
            size="small"
            options={organizations}
            getOptionLabel={(option) => option.name || ''}
            value={selectedOrg}
            onChange={(_, newValue) => {
              setSelectedOrg(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Select Organization"
                sx={{ width: '240px' }}
              />
            )}
          />

          <Autocomplete
            size="small"
            options={projects}
            getOptionLabel={(option) => option.name || ''}
            value={selectedProject}
            onChange={(_, newValue) => {
              setSelectedProject(newValue);
            }}
            disabled={!selectedOrg}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                placeholder="Select Project"
                sx={{ width: '240px' }}
              />
            )}
          />
        </Box>

        <Box sx={{ display: 'flex', gap: 1 }}>
          {checkedIds.length > 0 && (
            <>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleUpdateStatus(true)}
                sx={{
                  height: '32px',
                }}>
                Activate
              </Button>
              <Button
                variant="contained"
                color="secondary"
                onClick={() => handleUpdateStatus(false)}
                sx={{
                  height: '32px',
                }}>
                Deactivate
              </Button>
            </>
          )}
          <Button
            variant="contained"
            color="secondary"
            onClick={handleOpenDrawer}
            sx={{
              minWidth: '40px',
              width: '40px',
              height: '32px',
              padding: '4px',
            }}>
            <AddIcon fontSize="small" />
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleResetFilters}
            title="Reset to defaults"
            sx={{
              minWidth: '40px',
              width: '40px',
              height: '32px',
              padding: '4px',
            }}>
            <RestartAltIcon fontSize="small" />
          </Button>
        </Box>
      </Box>

      <CustomListView
        onRowClick={handleEditClick}
        columns={columns}
        data={allModules || []}
        page={page}
        pageSize={limit}
        count={count}
        setPageSize={handleLimit}
        setPage={handlePage}
        selectedSort={selectedSort}
        setSelectedSort={setSelectedSort}
        showCheckbox
        checkedIds={checkedIds}
        setCheckedIds={setCheckedIds}
      />

      {isDrawerOpen && (
        <ProjectModuleDrawer
          open={isDrawerOpen}
          onClose={handleCloseDrawer}
          module={selectedModule}
          onSuccess={getAll}
        />
      )}
    </>
  );
};

export default ProjectModules;
